import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { Result } from "../../types/Result";

export const userLoader: LoaderFunction = async (args) => {
    if (args.params.id === "new") {
        return new Promise((res) => res(Result.newResult()))
    }
    const result = await axiosApi.get("/api/users/" + args.params.id);
    return result.data
}